import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconLeft = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconLeft.dimensions.width} ${IconLeft.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M12.743.6L1.316 9.141C.524 9.635.002 10.578.002 11.593c0 1.015.522 1.958 1.381 2.497l11.36 8.497a1 1 0 101.197-1.602L2.514 12.442c-.344-.22-.512-.523-.512-.849 0-.326.168-.63.445-.803L13.94 2.2A1 1 0 0012.743.6z"
        fill={color || Color.premiumBlack}
        fillRule="nonzero"
      />
    </Svg>
  )
}

IconLeft.dimensions = {
  width: 15,
  height: 23,
}

export default IconLeft
